export enum DanceSchoolToUserErrorEnum {
  DELETE_LAST_OWNER = 'DELETE_LAST_OWNER',
  NOT_OWNER_ADD_OWNER_ADMIN = 'NOT_OWNER_ADD_OWNER_ADMIN',
  NOT_OWNER_OR_ADMIN_ADD_TEACHER = 'NOT_OWNER_OR_ADMIN_ADD_TEACHER',
  NO_RIGHTS_TO_DELETE = 'NO_RIGHTS_TO_DELETE',
  NOT_OWNER_UPDATE = 'NOT_OWNER_UPDATE',
  ONLY_OWNER_CAN_SET_OWNER = 'ONLY_OWNER_CAN_SET_OWNER',
  ONLY_OWNER_CAN_UPDATE_OWNER = 'ONLY_OWNER_CAN_UPDATE_OWNER',
}
